// extracted by mini-css-extract-plugin
export default {"notAvailableContainer":"ReportedTable_notAvailableContainer__PYwc+"};